import React from 'react';
import { useTranslation } from 'react-i18next';

import { EEmailVerificationStatus } from './use-email-verification';

function EmailVerifyBadge({
  status,
  suggestedEmail,
  onUseSuggestion,
}: {
  status: EEmailVerificationStatus;
  suggestedEmail: string | null;
  onUseSuggestion?: (email: string) => void;
}): React.JSX.Element | null {
  const { t } = useTranslation();

  if (status === EEmailVerificationStatus.Idle) {
    return null;
  }

  return (
    <p className="email-verify-badge">
      {status === EEmailVerificationStatus.Checking && (
        <span className="status-badge status-badge--info">
          {t('emailValidator.checking')}
        </span>
      )}
      {status === EEmailVerificationStatus.Ok && (
        <span className="status-badge status-badge--success">
          {t('emailValidator.ok')}
        </span>
      )}
      {status === EEmailVerificationStatus.NotOk && (
        <span className="status-badge status-badge--warning">
          {t('emailValidator.notOk')}
        </span>
      )}
      {suggestedEmail && onUseSuggestion && (
        <button
          type="button"
          className="email-verify-badge__suggestion"
          onClick={(): void => onUseSuggestion(suggestedEmail)}
        >
          {t('emailValidator.useSuggestion', { email: suggestedEmail })}
        </button>
      )}
    </p>
  );
}

export default EmailVerifyBadge;
